import { nextTick, ref } from 'vue';

export const useInternalChatAudio = (attachments, textInput, emit) => {
  const audioVisible = ref(false);
  const audioBusy = ref(false);
  const audioError = ref('');
  let recordedFile = null;

  const startAudio = () => {
    audioError.value = '';
    audioBusy.value = true;
    audioVisible.value = true;
    emit('typing', false);
  };

  const discardAudio = () => {
    attachments.value = attachments.value.filter(file => file !== recordedFile);
    recordedFile = null;
    audioVisible.value = false;
    audioBusy.value = false;
    nextTick(() => textInput.value?.focus());
  };

  const finishAudio = ({ file }) => {
    recordedFile = file;
    attachments.value = [...attachments.value, file];
  };

  const failAudio = ({ phase }) => {
    audioError.value =
      phase === 'microphone'
        ? 'INTERNAL_CHAT.AUDIO_MICROPHONE_FAILED'
        : 'INTERNAL_CHAT.AUDIO_CONVERSION_FAILED';
    discardAudio();
  };

  const removeAudio = file => {
    if (file === recordedFile) discardAudio();
  };

  const resetAudio = () => {
    recordedFile = null;
    audioVisible.value = false;
    audioBusy.value = false;
    audioError.value = '';
  };

  return {
    audioVisible,
    audioBusy,
    audioError,
    startAudio,
    discardAudio,
    finishAudio,
    failAudio,
    removeAudio,
    resetAudio,
  };
};
